import { DangerousHtmlContent, Notification, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { useFreeCancellationDaysAheadNotification } from '../../../../common/custom-hooks/freeCancellationDaysAheadNotification';
import type { BoundsType, TripSegmentType } from '../../models';

interface FreeCancellationNotificationProps {
  bounds: BoundsType;
}

const FreeCancellationNotification = ({ bounds }: FreeCancellationNotificationProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();
  const isValidForFreeCancellationDaysAhead = useFreeCancellationDaysAheadNotification(
    (bounds[0]?.segments[0] as TripSegmentType)?.departuredAt,
  );

  const testId = isValidForFreeCancellationDaysAhead
    ? 'freeCancellationInformationDaysAhead-search-result'
    : 'freeCancellationInformation-search-result';
  const content = isValidForFreeCancellationDaysAhead
    ? t('BookingFlow.FreeCancellation.DaysAhead.Text')
    : t('BookingFlow.FreeCancellation.Text');

  return isValidForFreeCancellationDaysAhead || p('BookingFlow.FreeCancellation.Enable') ? (
    <Notification dataTestId={testId} variant={variants.CONFIRMATION}>
      <DangerousHtmlContent content={content} />
    </Notification>
  ) : null;
};

export default FreeCancellationNotification;
